(function () {
  'use strict';
  var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var wishlistKey = 'praish_wishlist_v2';
  var q = function (selector, scope) { return (scope || document).querySelector(selector); };
  var qa = function (selector, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); };
  var escapeHtml = function (value) { var node = document.createElement('div'); node.textContent = value == null ? '' : String(value); return node.innerHTML; };
  var formatMoney = function (cents) {
    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'CAD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100); }
    catch (error) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
  };
  var getDialog = function (id) { return document.getElementById(id); };
  var closeDialog = function (dialog) {
    if (!dialog) return;
    if (dialog.open && dialog.close) dialog.close();
    document.body.classList.toggle('praish-dialog-open', !!q('.praish-dialog[open]'));
    var menuDialog = getDialog('PraishMenu');
    document.body.classList.toggle('praish-menu-open', !!(menuDialog && menuDialog.open));
  };
  var openDialog = function (id) {
    qa('.praish-card-sheet:not([hidden])').forEach(function (sheet) { sheet.hidden = true; });
    document.body.classList.remove('praish-quick-open');
    var dialog = getDialog(id);
    if (!dialog) return;
    qa('.praish-dialog[open]').forEach(function (open) { if (open !== dialog) closeDialog(open); });
    if (!dialog.open && dialog.showModal) dialog.showModal();
    document.body.classList.add('praish-dialog-open');
    document.body.classList.toggle('praish-menu-open', id === 'PraishMenu');
    if (id === 'PraishCart') refreshCart();
    if (id === 'PraishWishlist') renderWishlist();
    var focusTarget = id === 'PraishSearch' ? q('input[type="search"]', dialog) : q('input, button, a', dialog);
    if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 80);
  };
  qa('.praish-dialog').forEach(function (dialog) {
    dialog.addEventListener('close', function () { document.body.classList.toggle('praish-dialog-open', !!q('.praish-dialog[open]')); var menuDialog = getDialog('PraishMenu'); document.body.classList.toggle('praish-menu-open', !!(menuDialog && menuDialog.open)); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) closeDialog(dialog); });
  });
  var readWishlist = function () {
    try {
      var stored = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(stored) ? stored.filter(function (item) { return item && typeof item === 'object' && item.handle; }) : [];
    } catch (error) { return []; }
  };
  var writeWishlist = function (items) { try { localStorage.setItem(wishlistKey, JSON.stringify(items)); } catch (error) {} };
  var refreshWishlistButtons = function () {
    var handles = readWishlist().map(function (item) { return item.handle; });
    qa('[data-praish-wishlist]').forEach(function (button) {
      var active = handles.indexOf(button.dataset.productHandle) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };
  var renderWishlist = function () {
    var list = readWishlist();
    var container = q('[data-praish-saved-list]');
    var empty = q('[data-praish-saved-empty]');
    if (!container || !empty) return;
    container.innerHTML = '';
    empty.hidden = list.length > 0;
    list.forEach(function (item) {
      var article = document.createElement('article');
      article.className = 'praish-saved-item';
      var imageMarkup = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '<span></span>';
      article.innerHTML = imageMarkup + '<div class="praish-saved-item__content"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a><span>' + escapeHtml(item.price) + '</span></div><button type="button" data-praish-saved-remove="' + escapeHtml(item.handle) + '" aria-label="Remove saved product"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5.5 5.5 18.5 18.5M18.5 5.5 5.5 18.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg></button>';
      container.appendChild(article);
    });
  };
  var setButtonBusy = function (button, busy) {
    if (!button) return;
    button.classList.toggle('is-loading', busy);
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  };
  var addToCart = async function (variantId, button) {
    if (!variantId) return false;
    setButtonBusy(button, true);
    try {
      var response = await fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
      if (!response.ok) throw new Error('Cart add failed');
      await response.json();
      openDialog('PraishCart');
      return true;
    } catch (error) {
      if (button) button.classList.add('has-error');
      return false;
    } finally { setButtonBusy(button, false); }
  };
  var cartLineMarkup = function (item) {
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="praish-cart-drawer__variant">' + escapeHtml(item.variant_title) + '</span>' : '';
    var publicProperties = Object.keys(item.properties || {}).filter(function (key) { return key.charAt(0) !== '_' && item.properties[key]; });
    var properties = publicProperties.length ? '<span class="praish-cart-drawer__properties">' + publicProperties.map(function (key) { return '<small><b>' + escapeHtml(key) + ':</b> ' + escapeHtml(item.properties[key]) + '</small>'; }).join('') + '</span>' : '';
    var imageUrl = item.image ? item.image + (item.image.indexOf('?') >= 0 ? '&' : '?') + 'width=220' : '';
    var image = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title) + ' | PRAISH premium streetwear" loading="lazy">' : '<span class="praish-cart-drawer__placeholder"></span>';
    return '<article class="praish-cart-drawer__item"><a class="praish-cart-drawer__image" href="' + escapeHtml(item.url) + '">' + image + '</a><div class="praish-cart-drawer__item-content"><div class="praish-cart-drawer__item-head"><div><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant + properties + '</div><strong>' + formatMoney(item.final_line_price) + '</strong></div><div class="praish-cart-drawer__line-bottom"><div class="praish-quantity"><button type="button" data-praish-cart-change="-1" data-cart-key="' + escapeHtml(item.key) + '" data-cart-quantity="' + item.quantity + '" aria-label="Decrease quantity">&minus;</button><input value="' + item.quantity + '" readonly aria-label="Quantity"><button type="button" data-praish-cart-change="1" data-cart-key="' + escapeHtml(item.key) + '" data-cart-quantity="' + item.quantity + '" aria-label="Increase quantity">+</button></div><button class="praish-cart-drawer__remove" type="button" data-praish-cart-remove data-cart-key="' + escapeHtml(item.key) + '" aria-label="Remove item"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 7h14M9 7V4h6v3m2 0-.75 14h-8.5L7 7m3.25 4v6.5m3.5-6.5v6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg><span>Remove</span></button></div></div></article>';
  };
  var renderCart = function (cart) {
    qa('[data-praish-cart-count]').forEach(function (node) { node.textContent = cart.item_count; node.hidden = cart.item_count < 1; });
    qa('[data-praish-cart-heading-count]').forEach(function (node) { node.textContent = cart.item_count; });
    var items = q('[data-praish-cart-items]');
    var empty = q('[data-praish-cart-empty]');
    var footer = q('[data-praish-cart-footer]');
    if (items) items.innerHTML = cart.items.map(cartLineMarkup).join('');
    if (empty) empty.hidden = cart.item_count > 0;
    if (footer) footer.hidden = cart.item_count < 1;
    var total = q('[data-praish-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    qa('[data-praish-cart-checkout-total]').forEach(function (node) { node.textContent = formatMoney(cart.total_price); });
    var progress = q('[data-praish-shipping-progress]');
    if (progress) {
      var threshold = Number(progress.dataset.threshold) || 0;
      var remaining = Math.max(0, threshold - cart.total_price);
      var percent = threshold > 0 ? Math.min(100, cart.total_price / threshold * 100) : 100;
      var text = q('[data-praish-shipping-text]', progress);
      var bar = q('[data-praish-shipping-bar]', progress);
      if (text) text.textContent = remaining > 0 ? 'Spend ' + formatMoney(remaining) + ' more to unlock free shipping.' : 'You unlocked free shipping.';
      if (bar) bar.style.width = percent + '%';
    }
  };
  var refreshCart = async function () {
    try { var response = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } }); var cart = await response.json(); renderCart(cart); return cart; }
    catch (error) { return null; }
  };
  var changeCart = async function (key, quantity, button) {
    setButtonBusy(button, true);
    try {
      var response = await fetch(rootPath + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }) });
      if (!response.ok) throw new Error('Cart update failed');
      renderCart(await response.json());
    } catch (error) {} finally { setButtonBusy(button, false); }
  };
  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-praish-dialog-open]');
    if (open) { event.preventDefault(); openDialog(open.dataset.praishDialogOpen); return; }
    var close = event.target.closest('[data-praish-dialog-close]');
    if (close) { event.preventDefault(); closeDialog(close.closest('dialog')); return; }
    var switcher = event.target.closest('[data-praish-dialog-switch]');
    if (switcher) { event.preventDefault(); closeDialog(switcher.closest('dialog')); openDialog(switcher.dataset.praishDialogSwitch); return; }
    var wishlist = event.target.closest('[data-praish-wishlist]');
    if (wishlist) {
      event.preventDefault();
      var list = readWishlist();
      var handle = wishlist.dataset.productHandle;
      var index = list.findIndex(function (item) { return item.handle === handle; });
      if (index >= 0) list.splice(index, 1); else list.push({ handle: handle, url: wishlist.dataset.productUrl || '#', title: wishlist.dataset.productTitle || handle, price: wishlist.dataset.productPrice || '', image: wishlist.dataset.productImage || '' });
      writeWishlist(list); refreshWishlistButtons(); renderWishlist(); return;
    }
    var removeSaved = event.target.closest('[data-praish-saved-remove]');
    if (removeSaved) { writeWishlist(readWishlist().filter(function (item) { return item.handle !== removeSaved.dataset.praishSavedRemove; })); refreshWishlistButtons(); renderWishlist(); return; }
    var quickToggle = event.target.closest('[data-praish-quick-toggle]');
    if (quickToggle) {
      event.preventDefault();
      var sheet = document.getElementById(quickToggle.dataset.praishQuickToggle);
      qa('.praish-card-sheet:not([hidden])').forEach(function (other) { if (other !== sheet) other.hidden = true; });
      if (sheet) {
        sheet.hidden = !sheet.hidden;
        quickToggle.setAttribute('aria-expanded', sheet.hidden ? 'false' : 'true');
        document.body.classList.toggle('praish-quick-open', !sheet.hidden);
        if (!sheet.hidden) { var selectedQuick = q('[data-praish-quick-variant].is-selected', sheet); if (selectedQuick) selectedQuick.focus(); }
      }
      return;
    }
    var quickClose = event.target.closest('[data-praish-quick-close]');
    if (quickClose) {
      var quickSheet = quickClose.closest('.praish-card-sheet');
      if (quickSheet) quickSheet.hidden = true;
      document.body.classList.remove('praish-quick-open');
      return;
    }
    var quickVariant = event.target.closest('[data-praish-quick-variant]');
    if (quickVariant) {
      var variantSheet = quickVariant.closest('[data-praish-quick-sheet]');
      variantSheet.dataset.selectedVariant = quickVariant.dataset.praishQuickVariant;
      qa('[data-praish-quick-variant]', variantSheet).forEach(function (button) { var selected = button === quickVariant; button.classList.toggle('is-selected', selected); button.setAttribute('aria-pressed', selected ? 'true' : 'false'); });
      return;
    }
    var quickAdd = event.target.closest('[data-praish-quick-add]');
    if (quickAdd) {
      var addSheet = quickAdd.closest('[data-praish-quick-sheet]');
      addToCart(addSheet.dataset.selectedVariant, quickAdd).then(function (added) { if (added) { addSheet.hidden = true; document.body.classList.remove('praish-quick-open'); } });
      return;
    }
    var quickBuy = event.target.closest('[data-praish-quick-buy]');
    if (quickBuy) {
      var buySheet = quickBuy.closest('[data-praish-quick-sheet]');
      window.location.href = rootPath + 'cart/' + buySheet.dataset.selectedVariant + ':1?checkout';
      return;
    }
    var directAdd = event.target.closest('[data-praish-direct-add]');
    if (directAdd) { event.preventDefault(); addToCart(directAdd.dataset.praishDirectAdd, directAdd).then(function (added) { if (added) { var sheetParent = directAdd.closest('.praish-card-sheet'); if (sheetParent) sheetParent.hidden = true; } }); return; }
    var cartChange = event.target.closest('[data-praish-cart-change]');
    if (cartChange) { var nextQuantity = Number(cartChange.dataset.cartQuantity) + Number(cartChange.dataset.praishCartChange); changeCart(cartChange.dataset.cartKey, nextQuantity, cartChange); return; }
    var cartRemove = event.target.closest('[data-praish-cart-remove]');
    if (cartRemove) { changeCart(cartRemove.dataset.cartKey, 0, cartRemove); return; }
    var pageQuantity = event.target.closest('[data-praish-page-quantity]');
    if (pageQuantity) { var pageInput = q('input[type="number"]', pageQuantity.closest('.praish-quantity')); if (pageInput) pageInput.value = Math.max(0, Number(pageInput.value) + Number(pageQuantity.dataset.praishPageQuantity)); return; }
    if (!event.target.closest('.praish-product-card')) {
      qa('.praish-card-sheet:not([hidden])').forEach(function (sheet) { sheet.hidden = true; });
      document.body.classList.remove('praish-quick-open');
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    qa('.praish-card-sheet:not([hidden])').forEach(function (sheet) { sheet.hidden = true; });
    document.body.classList.remove('praish-quick-open');
  });
  var setGenderGrid = function (grid, gender) {
    var visible = 0;
    var productLimit = Number(grid.dataset.productLimit || 50);
    qa('[data-praish-gender-toggle]', grid).forEach(function (button) {
      var active = button.dataset.praishGenderToggle === gender;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    qa('[data-praish-gender-product]', grid).forEach(function (product) {
      var genders = (product.dataset.gender || '').split(/\s+/);
      var show = genders.indexOf(gender) !== -1 && visible < productLimit;
      product.hidden = !show;
      if (show) visible += 1;
    });
    var empty = q('[data-praish-gender-empty]', grid);
    if (empty) empty.hidden = visible > 0;
  };
  qa('[data-praish-gender-grid]').forEach(function (grid) { setGenderGrid(grid, 'men'); });
  document.addEventListener('click', function (event) {
    var genderButton = event.target.closest('[data-praish-gender-toggle]');
    if (!genderButton) return;
    var grid = genderButton.closest('[data-praish-gender-grid]');
    if (grid) setGenderGrid(grid, genderButton.dataset.praishGenderToggle);
  });
  qa('[data-product-root]').forEach(function (productRoot) {
    var form = q('.praish-product-form', productRoot);
    var variantData = q('[data-variant-json]', form);
    if (!form || !variantData) return;
    var variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (error) {}
    var idInput = q('[data-praish-variant-id]', form);
    var atc = q('[data-praish-atc]', form);
    var buyNow = q('[data-praish-buy-now]', form);
    var status = q('[data-praish-product-status]', form);
    var groups = qa('[data-option-position]', form);
    var selectedOptions = function () { return groups.map(function (group) { var selected = q('input:checked', group); return selected ? selected.value : null; }); };
    var findVariant = function (options) { return variants.find(function (variant) { return variant.options.every(function (value, index) { return String(value) === String(options[index]); }); }); };
    var syncAvailability = function () {
      var selected = selectedOptions();
      groups.forEach(function (group, groupIndex) {
        qa('input[type="radio"]', group).forEach(function (input) {
          var trial = selected.slice(); trial[groupIndex] = input.value;
          var available = variants.some(function (variant) { return variant.available && variant.options.every(function (value, index) { return index > groupIndex || String(value) === String(trial[index]); }); });
          input.disabled = !available;
          var label = document.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-disabled', !available);
        });
      });
    };
    var updateVariant = function () {
      var variant = findVariant(selectedOptions());
      if (variant && idInput) idInput.value = variant.id;
      var available = !!(variant && variant.available);
      if (atc) { atc.disabled = !available; atc.textContent = available ? 'ADD TO BAG' : 'SOLD OUT'; }
      if (buyNow) buyNow.disabled = !available;
      if (status) status.textContent = variant ? '' : 'This option combination is unavailable.';
      var price = q('.praish-product-price', productRoot);
      if (price && variant) price.innerHTML = '<span' + (variant.compare_at_price > variant.price ? ' class="praish-price__sale"' : '') + '>' + formatMoney(variant.price) + '</span>' + (variant.compare_at_price > variant.price ? '<s class="praish-price__compare">' + formatMoney(variant.compare_at_price) + '</s>' : '');
      if (variant && variant.featured_media) {
        var media = q('[data-media-id="' + variant.featured_media.id + '"]', productRoot);
        var track = q('.praish-product-gallery__track', productRoot);
        if (media && track) {
          if (window.matchMedia('(min-width: 990px)').matches) media.scrollIntoView({ behavior: 'smooth', block: 'start' });
          else track.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
        }
      }
      if (variant && window.history && window.history.replaceState) window.history.replaceState({}, '', productRoot.dataset.productUrl + '?variant=' + variant.id);
      syncAvailability();
      return variant;
    };
    form.addEventListener('change', updateVariant);
    form.addEventListener('submit', function (event) { event.preventDefault(); var variant = updateVariant(); if (variant && variant.available) addToCart(variant.id, atc); });
    if (buyNow) buyNow.addEventListener('click', function () { var variant = updateVariant(); if (variant && variant.available) window.location.href = rootPath + 'cart/' + variant.id + ':1?checkout'; });
    syncAvailability();
  });
  qa('[data-praish-gallery]').forEach(function (gallery) {
    var track = q('.praish-product-gallery__track', gallery);
    var current = q('[data-praish-gallery-current]', gallery);
    var dots = qa('[data-praish-gallery-dot]', gallery);
    if (!track) return;
    var update = function () { var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); if (current) current.textContent = index + 1; dots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === index); }); };
    track.addEventListener('scroll', update, { passive: true });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { track.scrollTo({ left: Number(dot.dataset.praishGalleryDot) * track.clientWidth, behavior: 'smooth' }); }); });
    update();
  });
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-praish-tab]');
    if (!tab) return;
    var tabs = tab.closest('[data-praish-tabs]');
    qa('[data-praish-tab]', tabs).forEach(function (button) { var active = button === tab; button.classList.toggle('is-active', active); button.setAttribute('aria-selected', active ? 'true' : 'false'); });
    qa('[data-praish-panel]', tabs).forEach(function (panel) { var active = panel.dataset.praishPanel === tab.dataset.praishTab; panel.classList.toggle('is-active', active); panel.hidden = !active; });
  });
  var header = q('[data-praish-header]');
  var syncHeader = function () { if (header) header.classList.toggle('is-scrolled', window.scrollY > 16); };
  window.addEventListener('scroll', syncHeader, { passive: true });
  syncHeader();
  document.addEventListener('praish:cart:open', function () { openDialog('PraishCart'); });
  var initialCart = q('[data-praish-cart-initial]');
  if (initialCart) { try { renderCart(JSON.parse(initialCart.textContent)); } catch (error) { refreshCart(); } }
  refreshWishlistButtons();

  qa('[data-praish-predictive-form]').forEach(function (form) {
    var input = q('input[type="search"]', form);
    var results = q('[data-praish-predictive-results]', form.closest('.praish-search-surface'));
    var status = q('[data-praish-predictive-status]', form);
    if (!input || !results) return;
    var initialMarkup = results.innerHTML;
    var timer = 0;
    var controller = null;
    var renderPredictive = function (data, term) {
      var resourceResults = data && data.resources && data.resources.results ? data.resources.results : {};
      var products = form.dataset.showProducts === 'true' ? (resourceResults.products || []) : [];
      var collections = form.dataset.showCollections === 'true' ? (resourceResults.collections || []) : [];
      var html = '';
      if (products.length) {
        html += '<section class="praish-predictive-group"><h2>Products</h2><div class="praish-predictive-products">';
        products.forEach(function (product) {
          var imageSource = typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image && product.featured_image.url ? product.featured_image.url : '');
          var imageUrl = imageSource ? imageSource + (imageSource.indexOf('?') >= 0 ? '&' : '?') + 'width=240' : '';
          var image = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(product.title) + ' | PRAISH premium streetwear search result" loading="lazy">' : '<span class="praish-predictive-placeholder"></span>';
          var productPrice = product.price_min != null ? product.price_min : product.price;
          html += '<a href="' + escapeHtml(product.url) + '">' + image + '<span><strong>' + escapeHtml(product.title) + '</strong><small>' + formatMoney(productPrice || 0) + '</small></span></a>';
        });
        html += '</div></section>';
      }
      if (collections.length) {
        html += '<section class="praish-predictive-group"><h2>Collections</h2><div class="praish-predictive-collections">';
        collections.forEach(function (collection) {
          var rawCollectionImage = typeof collection.image === 'string' ? collection.image : (collection.image && collection.image.url ? collection.image.url : '');
          var collectionImageUrl = rawCollectionImage ? rawCollectionImage + (rawCollectionImage.indexOf('?') >= 0 ? '&' : '?') + 'width=150' : '';
          var collectionImage = collectionImageUrl ? '<img src="' + escapeHtml(collectionImageUrl) + '" alt="' + escapeHtml(collection.title) + ' PRAISH collection" loading="lazy">' : '<span class="praish-predictive-placeholder"></span>';
          html += '<a href="' + escapeHtml(collection.url) + '">' + collectionImage + '<span>' + escapeHtml(collection.title) + '</span></a>';
        });
        html += '</div></section>';
      }
      if (!html) html = '<div class="praish-predictive-empty">No results for “' + escapeHtml(term) + '”</div>';
      results.innerHTML = html;
      if (status) status.textContent = products.length + collections.length + ' results available';
    };
    var requestSuggestions = function () {
      var term = input.value.trim();
      if (term.length < 2) { if (controller) controller.abort(); results.innerHTML = initialMarkup; if (status) status.textContent = ''; return; }
      if (controller) controller.abort();
      controller = new AbortController();
      results.classList.add('is-loading');
      var types = [];
      if (form.dataset.showProducts === 'true') types.push('product');
      if (form.dataset.showCollections === 'true') types.push('collection');
      var endpoint = rootPath + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=' + encodeURIComponent(types.join(',')) + '&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      fetch(endpoint, { signal: controller.signal, headers: { 'Accept': 'application/json' } }).then(function (response) { if (!response.ok) throw new Error('Predictive search failed'); return response.json(); }).then(function (data) { renderPredictive(data, term); }).catch(function (error) { if (error.name !== 'AbortError' && status) status.textContent = 'Search suggestions are unavailable.'; }).finally(function () { results.classList.remove('is-loading'); });
    };
    input.addEventListener('input', function () { window.clearTimeout(timer); timer = window.setTimeout(requestSuggestions, 180); });
    form.addEventListener('submit', function (event) { if (!input.value.trim()) event.preventDefault(); });
  });
})();